import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, NavigationEnd, ActivatedRoute, ParamMap } from '@angular/router';
import 'rxjs/add/operator/switchMap';
@Component({
  selector: 'fihe-main-view',
  templateUrl: './main-view.component.html',
  styleUrls: ['./main-view.component.scss']
})
export class MainViewComponent implements OnInit {

  sub;
  sub1;
  sub2;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ) {
    this.sub2 = location.subscribe(() => {

      window['fi_refresh'] = true;

   });

    this.sub1 = router.events.subscribe(this.routeChange);
  }

  routeChange(val){

    if ( val instanceof NavigationEnd ) {
  
    }
  }

  ngOnInit() {

    this.sub = this.route.params.subscribe(params => {

    });

  }


  ngOnDestroy() {
   this.sub.unsubscribe();
   this.sub1.unsubscribe();
   this.sub2.unsubscribe();
 }

}



// WEBPACK FOOTER //
// ./src/app/main-view/main-view.component.ts